import {Person} from '../person/person';

export class UserApplication {

  id!: number;
  userName!: string;
  firstName!: string;
  lastName!: string;
  orgName!: string;
  jobTitle!: string;
  workEmail!: string;
  phoneNumber!: string;
  supervisor!: Person;
  personRecord!: Person;

}
